"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _kitten_sort = require("@/api/kitten_sort");

var actions = {
  edit: function edit(_ref, catInfo) {
    var commit = _ref.commit;
    // const { name, sex } = catInfo
    return new Promise(function (resolve, reject) {
      (0, _kitten_sort.edit)(catInfo).then(function (response) {
        var data = response.data; // commit('SET_NAME', name)

        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};
var _default = {
  namespaced: true,
  // state,
  // mutations,
  actions: actions
};
exports.default = _default;